/**
 *  @class
 *  @function PredictiveSearch
 */
class PredictiveSearch {
  constructor() {
    this.container = document.getElementById('Search-Drawer');
    this.form = this.container.querySelector('.search-drawer--searchform');
    this.button = document.querySelectorAll('.thb-quick-search');
    this.input = this.container.querySelector('input[type="search"]');
    this.predictiveSearchResultsWrapper = this.container.querySelector('.search-drawer--inner');
    this.predictiveSearchResults = this.predictiveSearchResultsWrapper.querySelector('.thb-predictive-search');

    this.historyWrapper = this.container.querySelector('.search-history-wrapper');
    this.recentBox = this.container.querySelector('.recent-search');
    this.clearHistoryBtn = this.container.querySelector(".clear-history");
    
    this.showHistory();
    this.deleteHistoryItem();
    this.deleteAllHistory();
    
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 1000).bind(this));

    this.button.forEach((item, i) => {
      item.addEventListener('click', (event) => {
        var _this = this;
        event.preventDefault();        
        document.body.classList.toggle('open-search');
        document.body.classList.toggle('open-cc');
        if (document.body.classList.contains('open-search')) {
          this.container.style.display = "block";
           requestAnimationFrame(() => {
             this.container.classList.add('visible');
           });
          setTimeout(function () {
            _this.input.focus({
              preventScroll: true
            });
          }, 100);
          dispatchCustomEvent('search:open');
        }

        return false;
      });
    });
  }

  getQuery() {
    return this.input.value.trim();
  }
  
  /*显示搜索历史*/
  showHistory() {   
    const searchHistory = JSON.parse(localStorage.getItem("searchHistory")) || [];
    if (searchHistory.length > 0) {
      this.clearHistoryBtn.style.display = "block";
      this.historyWrapper.style.display = "block";
      this.recentBox.innerHTML = searchHistory.map((term, index) => `
        <div class="recent-item">
          <span>${term}</span>
          <button class="delete-item" data-index="${index}">x</button>
        </div>
      `).join('');
    } else {
      this.clearHistoryBtn.style.display = "none";
       this.historyWrapper.style.display = "none";
    }
  }

 deleteHistoryItem() {
    // 删除单个历史记录项
    this.recentBox.addEventListener("click", (e) => {
      e.preventDefault(); 
      
      if (e.target.classList.contains("delete-item")) {
        const index = e.target.getAttribute("data-index");
        let searchHistory = JSON.parse(localStorage.getItem("searchHistory")) || [];
        searchHistory.splice(index, 1);
        localStorage.setItem("searchHistory", JSON.stringify(searchHistory));
        this.showHistory(); // 刷新显示
        // 如果删除后没有历史记录了，可以清空 recentBox 以防止误操作
        if (searchHistory.length === 0) {
          this.recentBox.innerHTML = '';
        }
      } else if (e.target.classList.contains("recent-item") || e.target.tagName === 'SPAN') {
        this.input.value = e.target.closest(".recent-item").querySelector("span").textContent;
        
      // 触发搜索，调用 onChange 方法
      this.onChange();
      }
    });
  }

  deleteAllHistory() {
    // 清空所有历史记录
    this.clearHistoryBtn.addEventListener("click", () => {
      localStorage.removeItem("searchHistory");
      this.recentBox.innerHTML = ''; 
      this.clearHistoryBtn.style.display = "none";
       this.historyWrapper.style.display = "none";
    });
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.container.classList.remove('active');
      return;
    }
    this.container.classList.add('active');
    this.getSearchResults(searchTerm);

    
    /*add search history to the localstorage */
    if (searchTerm) {
      let searchHistory = JSON.parse(localStorage.getItem("searchHistory")) || [];
      // 防止重复添加搜索词
      if (!searchHistory.includes(searchTerm)) {
        searchHistory.push(searchTerm);
        // 只保留最近 5 个搜索词
        if (searchHistory.length > 5) {
          searchHistory.shift();
        }
        localStorage.setItem("searchHistory", JSON.stringify(searchHistory));
      }
      this.showHistory();
      
    }
  }

  onFormSubmit(event) {
    if (!this.getQuery().length) {
      event.preventDefault();
    }
  }

  onFocus() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();

    this.predictiveSearchResults.classList.add('loading');

    fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,collection,article,query&${encodeURIComponent('resources[limit]')}=6&section_id=predictive-search`)
      .then((response) => {
        this.predictiveSearchResults.classList.remove('loading');
        if (!response.ok) {
          var error = new Error(response.status);
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;

        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        throw error;
      });
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;

    let _this = this,
      submitButton = this.container.querySelector('#search-results-submit');

    if (document.body.classList.contains('animations-true')) {
      gsap.to(this.predictiveSearchResults.querySelectorAll('.product-card .product-featured-image-link'), { scale: 1, opacity: 1, stagger: 0.15, ease: window.theme.settings.animation_easing });
    }
    submitButton.addEventListener('click', () => {
      _this.form.submit();
    });

  /*
    // 添加埋点发送事件到杨文博添加的自建服务器上，用于BI看板数据分析
  const productEls = this.predictiveSearchResults.querySelectorAll('.product-card');
  let firstProductData = null;
  if (productEls.length > 0) {
    const firstEl = productEls[0];
    firstProductData = {
      productTitle: firstEl.querySelector('.product-card-title')?.innerText || null,
      productId: firstEl.dataset?.productId || null
    };
  }
  window.ShopifyTracking = {
    customerId: {{ customer.id | json }},
    shopName: {{  shop.name | json }}
  };
  function getClientId() {
    let id = localStorage.getItem("client_id");
    if (!id) {
      id = crypto.randomUUID();
      localStorage.setItem("client_id", id);
    }
    return id;
  }
  function getSessionId() {
    let id = sessionStorage.getItem("session_id");
    if (!id) {
      id = crypto.randomUUID();
      sessionStorage.setItem("session_id", id);
    }
    return id;
  }

  // 🔹 发送事件到你自己的埋点 API
  fetch('https://shopifyapi.huashuohair.cn:801/api/api_search', {       // 替换成你的接口
    method: 'POST',
    headers: {
      "Content-Type": "application/json"
    },
    keepalive: true,
    body: JSON.stringify({
      shopName: window.ShopifyTracking.shopName,
      eventName: 'search_instant',
      timestamp: new Date().toISOString(),
      eventId: getSessionId(),
      clientId: getClientId(),
      customerId: window.ShopifyTracking.customerId || null,
      title: document.title,
      url: location.href,
      referrer: document.referrer,
      search: {
        searchQuery: this.getQuery(),
        firstProductTitle: firstProductData.productTitle,
        firstProductId: firstProductData.productId,
      }  
    })
  })
  .then(res => res.text())
  .then(data => console.log("发送成功", data))
  .catch(err => console.error("发送失败", err));
 */

  }

  close() {
    this.container.classList.remove('active');
    this.container.classList.remove('visible');
  }
}

window.addEventListener('load', () => {
  if (typeof PredictiveSearch !== 'undefined') {
    new PredictiveSearch();
  }
});
